<template>
  <div class="d-flex justify-center flex-column pt-0 mb-0">
    <v-img
      alt="Business Banner"
      class="grey darken-4"
      max-height="300"
      :src="banner_src"
    >
      <div class="business-header-div redx d-flex align-end pl-4 pr-4 pb-2">
        <div>
          <v-avatar tile color="grey" size="164" class="logo-avatar">
            <v-img cover :src="logo_src" alt="Company Logo" />
          </v-avatar>
        </div>
        <div
          class="flex-grow-1 d-flex flex-column justify-space-between business-name-div"
        >
          <div class="business-name">
            {{ business.name }}
          </div>
          <div class="business-sub-name">{{ business.tag_line }}</div>
          <div class="business-small-facts d-flex justify-space-between">
            <span class="success--text local-badge"
              ><small>
                {{
                  parseInt(business.is_local_company) == 1
                    ? "LOCAL COMPANY"
                    : "NOT LOCAL"
                }}
              </small></span
            >
            <span><small>Joinned On:</small> {{ business.joined_on }}</span>
            <span
              ><small>Registered by:</small> {{ business.user.first_name }}
              {{ business.user.last_name }}</span
            >
          </div>
        </div>
        <div class="">
          <v-avatar color="grey" size="80">
            <v-img
              :src="verification_src[parseInt(business.is_verified)]"
              alt="Verification Stamp"
            />
          </v-avatar>
        </div>
      </div>
    </v-img>
    <div class="d-flex justify-space-between align-center">
      <div class="text-left pl-2 pr-4">
        {{ parent_branch_name }}
      </div>
      <div>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          :to="'/owner/reports/searches?id=' + business.id"
          :disabled="is_loading"
          color="primary"
          v-if="is_owner"
        >
          <v-icon left>mdi-magnify</v-icon>
          <span class="text-decoration-underline"
            >Searches ({{ business.searches_count }})
          </span>
        </v-btn>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          :disabled="is_loading"
          color="primary"
          v-else
        >
          <v-icon left>mdi-magnify</v-icon>
          <span>Searches ({{ business.searches_count }}) </span>
        </v-btn>
      </div>
      <div>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          :to="'/owner/reports/views?id=' + business.id"
          :disabled="is_loading"
          color="primary"
          v-if="is_owner"
        >
          <v-icon left>mdi-eye</v-icon>
          <span class="text-decoration-underline"
            >Views ({{ business.views_count }})
          </span>
        </v-btn>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          :disabled="is_loading"
          color="primary"
          v-else
        >
          <v-icon left>mdi-eye</v-icon>
          <span>Views ({{ business.views_count }}) </span>
        </v-btn>
      </div>
      <div>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          :to="'/owner/reports/reviews?id=' + business.id"
          :disabled="is_loading"
          color="primary"
          v-if="is_owner"
        >
          <v-icon left>mdi-comment-text-multiple</v-icon>
          <span class="text-decoration-underline"
            >Reviews ({{ business.reviews_count }})
          </span>
        </v-btn>
        <v-btn
          small
          text
          class="mr-2 ml-2"
          @click="
            $emit('on-scroll-to', 'owner_view_business_reviews_list_section')
          "
          :disabled="is_loading"
          color="primary"
          v-else
        >
          <v-icon left>mdi-comment-text-multiple</v-icon>
          <span class="text-decoration-underline"
            >Reviews ({{ business.reviews_count }})
          </span>
        </v-btn>
      </div>
      <div class="flex-grow-1">&nbsp;</div>

      <div>
        <v-rating
          background-color="warning lighten-1"
          color="warning"
          empty-icon="mdi-star-outline"
          full-icon="mdi-star"
          half-icon="mdi-star-half-full"
          hover
          length="5"
          size="20"
          :value="parseFloat(business.rating)"
          :readonly="true"
        ></v-rating>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../lib/Utils";
export default {
  name: "BusinessViewHeader",
  props: {
    business: {
      type: Object,
      default() {
        return Utils.get_default_business();
      },
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      verification_src: {
        0: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508894/botswana%20services/website%20assets/verification_missing_rrfc7y.png",
        1: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607508093/botswana%20services/website%20assets/verification_pending_cp3bln.png",
        2: "https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1607507535/botswana%20services/website%20assets/verified_stamp_xqikbc.jpg",
      },
    };
  },
  computed: {
    banner_src() {
      var str = "";
      if (parseInt(this.business.id) == 0) {
        str = Utils.default_business_banner;
      } else {
        var temp =
          this.business.banner != null && this.business.banner.length > 0
            ? this.business.banner
            : "";
        temp = temp.trim();
        if (temp.length > 0) {
          str = temp;
        } else {
          str = Utils.default_business_banner;
        }
      }
      return str;
    },
    logo_src() {
      var str = "";
      if (parseInt(this.business.id) == 0) {
        str = Utils.default_business_logo;
      } else {
        str = this.business.logo;
      }
      return str;
    },
    parent_branch_name() {
      var str = "";
      //adopted from the add component
      var branch_types = [
        { id: 0, name: "No Branch" },
        { id: 1, name: "Main Branch" },
        { id: 2, name: "Is Sub Branch" },
      ];
      var bt = parseInt(this.business.is_main_branch);
      //console.log("bt", bt);
      if (bt == 0 || bt == 1) {
        str = branch_types[bt].name;
      } else {
        if (
          this.business.parent_branch &&
          this.business.parent_branch != null
        ) {
          str = this.business.parent_branch.name;
        }
      }
      return str;
    },
  },
};
</script>

<style scoped>
.logo-avatar {
  border-radius: 15px !important;
  border-bottom-right-radius: 0px !important;
}
.business-header-div {
  height: 300px;
}

.business-name-div {
  background-color: #fff6f694;
  max-height: 200px;
  height: 50%;
  padding: 10px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.business-name {
  text-align: left;
  font-size: 24px;
  font-weight: bold;
  text-transform: capitalize;
  text-shadow: 2px 1px 2px white;
  border-bottom: 1px dotted #ded3d3;
}
.business-sub-name {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  text-transform: capitalize;
  text-shadow: 1px 0px 1px #ffffff8f;
  border-bottom: 1px dotted #ded3d3;
}
.business-small-facts {
  font-weight: bold;
}
.local-badge {
  text-shadow: 0px 1px 0px #ffffff;
  background-color: #ffffffc9;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
}
</style>